import React from 'react'

export const Evening = (props:any) => {
	return (<svg width="26" height="11" viewBox="0 0 26 11" fill="none" xmlns="http://www.w3.org/2000/svg">
	<path d="M25 8.31043H21.16C20.9955 6.25133 20.0672 4.32808 18.5575 2.91824C17.0477 1.5084 15.0655 0.713805 13 0.69043C10.9345 0.713805 8.95226 1.5084 7.44252 2.91824C5.93277 4.32808 5.00452 6.25133 4.84 8.31043H1C0.734784 8.31043 0.48043 8.41579 0.292893 8.60332C0.105357 8.79086 0 9.04521 0 9.31043C0 9.57565 0.105357 9.83 0.292893 10.0175C0.48043 10.2051 0.734784 10.3104 1 10.3104H25C25.2652 10.3104 25.5196 10.2051 25.7071 10.0175C25.8946 9.83 26 9.57565 26 9.31043C26 9.04521 25.8946 8.79086 25.7071 8.60332C25.5196 8.41579 25.2652 8.31043 25 8.31043ZM13 2.69043C14.5355 2.71156 16.0098 3.29543 17.1434 4.33132C18.2769 5.36721 18.991 6.78309 19.15 8.31043H6.85C7.00905 6.78309 7.72307 5.36721 8.85665 4.33132C9.99023 3.29543 11.4645 2.71156 13 2.69043Z" fill="white"/>
	</svg>
	)
}





